export const enum Role {
    Basis = 1,
    Joker = 2,
    Admin = 4,
    SuperAdmin = 8,
    Group = 16, // Not an actual role, just to defaine what is visibe for a group
}